import { render } from 'react-dom';

interface AppendComponentIfNotExistConfigT {
  Component: React.FC;
  parentVisibility?: string;
  uidSelector: string;
  tagName: string;
}

// appendComponentIfNotExist is a function that appends a component to the DOM if it does not exist
// it returns the element appended
//
export const appendComponentIfNotExist = async (props: AppendComponentIfNotExistConfigT) => {
  const { Component, parentVisibility = 'hidden', uidSelector, tagName = 'span' } = props;

  // if elementAttached exists we return it
  const elementAttached = document.getElementById(uidSelector);
  if (elementAttached) return elementAttached;
  const rootElement = document.createElement(tagName);
  rootElement.style.visibility = parentVisibility;

  // we wait for the component to be rendered and then we return the element appended
  const element = await new Promise<HTMLElement>((resolve) => {
    render(<Component />, document.body.appendChild(rootElement));
    requestAnimationFrame(() => {
      resolve(document.getElementById(uidSelector) as HTMLElement);
    });
  });
  return element;
};
